module.exports = __webpack_public_path__ + "static/media/banner_sm.6518cbed.svg";